function fixDateString(s) {
  if (typeof s !== "string") return "";
  return s.replace(/(\.\d{3})\d+$/, "$1");
}

export function formatDateTime(dateString, opts = {}) {
  if (!dateString) return "";
  const { timeZone, showSeconds } = opts;
  try {
    const tz = timeZone || Intl.DateTimeFormat().resolvedOptions().timeZone;

    const fixed = fixDateString(String(dateString));
    const utcString = fixed.endsWith("Z") ? fixed : fixed + "Z";

    const date = new Date(utcString);
    if (Number.isNaN(date.getTime())) return String(dateString);

    const dateStr = date.toLocaleDateString("en-US", {
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
      timeZone: tz,
    });
    const timeStr = date.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      ...(showSeconds && { second: "2-digit" }),
      hour12: true,
      timeZone: tz,
    });
    return `${dateStr} ${timeStr}`;
  } catch (error_) {
    console.error("Unexpected error", error_);
    return String(dateString);
  }
}

export function formatDateOnly(dateString, opts = {}) {
  if (!dateString) return "";
  const { timeZone } = opts;
  try {
    const tz = timeZone || Intl.DateTimeFormat().resolvedOptions().timeZone;
    const fixed = fixDateString(String(dateString));
    const utcString = fixed.endsWith("Z") ? fixed : fixed + "Z";
    const date = new Date(utcString);
    if (Number.isNaN(date.getTime())) return String(dateString);
    return date.toLocaleDateString("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
      timeZone: tz,
    });
  } catch (error_) {
    console.error("Unexpected error", error_);
    return String(dateString);
  }
}

export function formatTimeOnly(dateString, opts = {}) {
  if (!dateString) return "";
  const { timeZone, showSeconds } = opts;
  try {
    const tz = timeZone || Intl.DateTimeFormat().resolvedOptions().timeZone;
    const fixed = fixDateString(String(dateString));
    const utcString = fixed.endsWith("Z") ? fixed : fixed + "Z";
    const date = new Date(utcString);
    if (Number.isNaN(date.getTime())) return String(dateString);
    return date.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      ...(showSeconds && { second: "2-digit" }),
      hour12: true,
      timeZone: tz,
    });
  } catch (error_) {
    console.error("Unexpected error", error_);
    return String(dateString);
  }
}

export default formatDateTime;
